"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEventTemplateMapping = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
const notification_template_entity_1 = require("./notification-template.entity");
let NotificationEventTemplateMapping = class NotificationEventTemplateMapping {
};
exports.NotificationEventTemplateMapping = NotificationEventTemplateMapping;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventTemplateMapping.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "event_type_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventTemplateMapping.prototype, "eventTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "template_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventTemplateMapping.prototype, "templateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], NotificationEventTemplateMapping.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_event_type_entity_1.NotificationEventType),
    (0, typeorm_1.JoinColumn)({ name: 'event_type_id' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof notification_event_type_entity_1.NotificationEventType !== "undefined" && notification_event_type_entity_1.NotificationEventType) === "function" ? _a : Object)
], NotificationEventTemplateMapping.prototype, "eventType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_template_entity_1.NotificationTemplate),
    (0, typeorm_1.JoinColumn)({ name: 'template_id' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof notification_template_entity_1.NotificationTemplate !== "undefined" && notification_template_entity_1.NotificationTemplate) === "function" ? _b : Object)
], NotificationEventTemplateMapping.prototype, "template", void 0);
exports.NotificationEventTemplateMapping = NotificationEventTemplateMapping = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_event_template_mapping')
], NotificationEventTemplateMapping);
